import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import type { QueryParam } from './query-helpers';

@Injectable({
  providedIn: 'root',
})
export class QueryParamService {
  constructor(private route: ActivatedRoute) {}

  /**
   * Gets the current query parameters from the route
   * This is the default client-side implementation
   */
  getQueryParams(): QueryParam {
    return this.route.snapshot.queryParams;
  }

  /**
   * Gets a specific query parameter value
   */
  getQueryParam(key: string): string | null {
    // Added defensive optional chaining so tests/components that provide a partial ActivatedRoute
    // (missing snapshot.queryParamMap) don't throw. Returns null when unavailable.
    return this.route?.snapshot?.queryParamMap?.get?.(key) ?? null;
  }
}
